var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Grp',{attrs:{"id":"status_prt_ea1","stacked":true,"aspectRatio":5,"datasets":_vm.grp.datasets,"labels":_vm.grp.labels},on:{"update:datasets":function($event){return _vm.$set(_vm.grp, "datasets", $event)},"update:labels":function($event){return _vm.$set(_vm.grp, "labels", $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }